import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEquals = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33594 6H12.6693M3.33594 10H12.6693",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEquals;
